// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"imgBox___w2lMb","promptBox":"promptBox___P8h8S","imgList":"imgList___3PHQH"};